<template>
  <div id="privacy-policy-page">
    <div class="background-header d-flex justify-center">
      <v-img
        src="/img/pdpa/logo-pdpa.webp"
        width="250"
        height="250"
        contain
        class="logo"
      />
    </div>

    <div class="container">
      <div class="text-center">
        <h1>
          ข้อตกลงและเงื่อนไขทั่วไปในการใช้บริการผลิตภัณฑ์และบริการ
        </h1>
      </div>

      <!-- การใช้บริการผลิตภัณฑ์และบริการต่างๆ -->
      <div>
        <p>
          การใช้บริการผลิตภัณฑ์และบริการต่างๆ ที่ได้ระบุไว้ใน และ/หรือ นำเสนอโดย www.sellsuki.co.th
          ภายใต้การบริหารงานโดย บริษัท เซลสุกิ จำกัด (“บริษัท”) สำนักงานตั้งอยู่ ณ 10/39 ชั้นที่ 3
          ถนนรัชดาภิเษก แขวงจันทรเกษม เขตจตุจักร กรุงเทพมหานคร 10900 รวมถึง
          บริการผลิตภัณฑ์และบริการอย่างอื่นที่จะมีขึ้นในอนาคต (“ผลิตภัณฑ์และบริการ”)
          อยู่ภายใต้บังคับของข้อตกลงและเงื่อนไขทั่วไปในการใช้บริการผลิตภัณฑ์และบริการ
          (“เงื่อนไขในการใช้บริการทั่วไป”) และ ข้อตกลงและเงื่อนไขในการใช้บริการ
          เฉพาะรายผลิตภัณฑ์และบริการ (“เงื่อนไขในการใช้บริการเฉพาะ”)
        </p>
        <p class="my-10">
          เมื่อผู้ใช้บริการผลิตภัณฑ์ แอปพลิเคชัน และบริการต่าง ๆ ของบริษัท (“ผู้ใช้บริการ”)
          ได้เข้าถึง และ/หรือ เข้าสู่ระบบ แอปพลิเคชัน เพื่อใช้บริการเกี่ยวกับผลิตภัณฑ์และ
          บริการต่าง ๆ ผู้ใช้บริการได้ยืนยันและรับรองต่อบริษัท และ บริษัทจะถือว่า
          ผู้ใช้บริการได้ให้คำยืนยันและรับรองต่อบริษัทว่า ผู้ใช้บริการได้เข้าถึง ตรวจสอบ ศึกษา
          ซักถาม และ/หรือ รับทราบ รายละเอียดต่าง ๆ ของเงื่อนไขในการใช้บริการก่อนการ
          เข้าใช้บริการผลิตภัณฑ์และบริการ พร้อมทั้งผู้ใช้บริการยังได้ตกลง ยินยอม และ
          จะปฏิบัติตามเงื่อนไขในการใช้บริการต่าง ๆ (รวมถึง เงื่อนไขในการใช้บริการที่บริษัทอาจจะ
          ได้มีการปรับปรุงและแก้ไขเพิ่มเติมต่อไปในอนาคต) อย่างเคร่งครัด ทั้งนี้
          การเข้าถึง และ/หรือ การเข้าสู่ระบบ แอปพลิเคชัน เพื่อใช้บริการเกี่ยวกับผลิตภัณฑ์และบริการ
          ของผู้ใช้บริการในแต่ละครั้ง ให้ถือว่าผู้ใช้บริการได้ให้คำรับรองและ
          คำยืนยันดังกล่าวข้างต้นทุกครั้ง
        </p>
        <p>
          ภายใต้บังคับของเงื่อนไขในการใช้บริการเฉพาะซึ่งได้กล่าวไว้ในส่วนต่อไป
          ผู้ใช้บริการรับทราบและจะปฏิบัติตามเงื่อนไขในการใช้บริการทั่วไปที่ดังมีรายละเอียดต่อไปนี้
        </p>
      </div>

      <!-- 1. การแจ้งให้อ่านข้อมูล -->
      <div>
        <p class="font-weight-bold">
          1. การแจ้งให้อ่านข้อมูล
        </p>
        <p>
          ข้อความต่อไปนี้มีความสำคัญ กรุณาอ่านข้อกำหนดและเงื่อนไขการใช้บริการแอปพลิเคชัน
          นี้อย่างรอบคอบ เมื่อท่านได้กดตกลงแล้วจะถือว่าท่านตกลงว่า ท่านได้อ่าน
          เข้าใจ ยอมรับ และตกลงข้อกำหนดและเงื่อนไขการใช้บริการแอปพลิเคชัน
          เงื่อนไขที่ระบุในแบบฟอร์มการลงทะเบียน รวมถึงเอกสารอื่นๆ และข้อมูลใดๆ ที่บริษัท เซลสุกิ
          จำกัด ได้จัดเตรียมให้ (ไม่ว่าท่านจะได้ลงลายมือชื่อหรือไม่ก็ตาม) นอกจากนี้
          ท่านยังตกลงปฏิบัติตามคำรับรองที่ท่านได้ให้ไว้ หากท่านไม่ตกลงหรือไม่ปฏิบัติตามเงื่อนไข
          ในการใช้บริการ และประสงค์ที่จะไม่ใช้บริการต่อไป กรุณาหยุดใช้แอปพลิเคชัน หรือหยุดใช้บริการ
        </p>
      </div>

      <!-- 2. ผู้ใช้บริการ -->
      <div>
        <p class="font-weight-bold">
          2. ผู้ใช้บริการ
        </p>
        <p>
          ผู้ใช้บริการขอให้คำยืนยันและคำรับรองต่อบริษัทดังต่อไปนี้
        </p>
        <p>
          2.1 ในกรณีที่ผู้ใช้บริการเป็นบุคคลธรรมดาผู้ใช้บริการเป็นผู้บรรลุนิติภาวะหรือ
          มีอายุ 18 ปีขึ้นไปหรือในกรณีเป็นผู้เยาว์ต้องได้รับความยินยอมจากผู้แทนโดยชอบธรรมก่อน
        </p>
        <p>
          2.2 ในกรณีที่ผู้ใช้บริการเป็นนิติบุคคลหรือองค์กรใดๆ ผู้ติดต่อและ/หรือเข้าทำสัญญาใดๆ
          กับบริษัทเพื่อใช้บริการผลิตภัณฑ์และบริการต่างๆ ของผู้ใช้บริการเป็นผู้มีอำนาจ
          ผูกพัน และ/หรือ ได้รับการมอบอำนาจให้กระทำการแทนนิติบุคคลหรือองค์กรดังกล่าวอย่างสมบรูณ์
        </p>
        <p>
          2.3 เพื่อใช้บริการผลิตภัณฑ์และบริการต่างๆ ผู้ใช้บริการจะให้และ จะเปิดเผยข้อมูลต่างๆ
          ของผู้ใช้บริการให้ครบถ้วน ถูกต้องและ เป็นปัจจุบัน และผู้ใช้บริการจะจัดให้มีอีเมล
          และ/หรือ ช่องทางการสื่อสารทางระบบอินเทอร์เน็ตอย่างอื่น เพื่อการรับข้อมูลข่าวสารต่างๆ
          และ เป็นช่องทางติดต่อกับบริษัทอนึ่ง ในกรณีที่ข้อมูลต่างๆ ที่ผู้ใช้บริการได้ให้
          และ/หรือ เปิดเผย แก่บริษัทได้เปลื่ยนแปลงไป ผู้ใช้บริการมีหน้าที่และตกลงจะแก้ไขข้อมูลต่างๆ
          ดังกล่าวให้เป็นปัจจุบันอยู่เสมอ ซึ่งผู้ใช้บริการสามารถแก้ไขข้อมูลดังกล่าว
          ผ่านทางระบบการจัดการในเว็บไซต์ หรือ แอปพลิเคชัน ในกรณีที่บริษัทจัดให้มีระบบการจัดการ
          ให้แก้ไขข้อมูลหรือผู้ใช้บริการจะแจ้งการแก้ไขข้อมูลดังกล่าวไปยังเจ้าหน้าที่
          ของบริษัทที่ให้บริการแก่ผู้ใช้บริการ
        </p>
        <p>
          2.4 ผู้ใช้บริการได้ศึกษาและเข้าใจในคุณลักษณะ ข้อจำกัด และเงื่อนไขต่างๆ
          ของผลิตภัณฑ์และบริการต่างๆ ที่บริษัทได้จัดแสดงในหน้าเว็บไซต์ www.sellsuki.co.th หรือ
          แอปพลิเคชัน และผู้ใช้บริการได้ตัดสินใจใช้บริการผลิตภัณฑ์และบริการด้วยคุณลักษณะ
          ข้อจำกัด และเงื่อนไขต่าง ๆ ที่มีอยู่นี้ และยอมรับการเปลี่ยนแปลงคุณลักษณะ
          ข้อจำกัด และเงื่อนไขต่าง ๆ ที่จะมีในอนาคตซึ่งอาจจะมีผลทำให้ผู้ใช้บริการได้ใช้บริการ
          ผลิตภัณฑ์และบริการที่แตกต่างจากที่เคยได้ใช้บริการมาก่อนเช่น การใช้บริการผ่าน
          การทำงานในรูปแบบ หรือ Feature ที่แตกต่างไปจากเดิม
        </p>
        <p>
          2.5 ผู้ใช้บริการเป็นผู้ตัดสินใจเลือกใช้บริการผลิตภัณฑ์และบริการด้วยตัวเอง และ
          ในกรณีที่ผู้ใช้บริการที่เป็นนิติบุคคลหรือองค์กรใดๆ บริษัทจะถือว่า ผู้ใช้บริการเป็น
          ผู้รับผิดชอบต่อการตัดสินใจเลือกใช้บริการผลิตภัณฑ์และบริการนั้นๆ เอง หากมีปัญหาเกิดขึ้น
          ระหว่างผู้ใช้บริการกับผู้ติดต่อหรือตัวแทนของผู้ใช้บริการ ผู้ใช้บริการ
          รับทราบว่า บริษัทไม่มีหน้าที่ใดๆในการดำเนินการแก้ไขปัญหาดังกล่าวของผู้ใช้บริการ
        </p>
        <p>
          2.6 เมื่อได้รับการร้องขอจากบริษัท ผู้ใช้บริการจะส่งมอบเอกสาร และ/หรือ หลักฐานใดๆ
          ที่จำเป็นเพื่อแสดงว่าผู้ใช้บริการมีความสามารถ และ/หรือ อำนาจในการใช้บริการ
          ผลิตภัณฑ์และบริการที่ผู้ใช้บริการได้เลือกใช้บริการ เช่น บัตรประชาชน ทะเบียนบ้าน
          หนังสือรับรองของบริษัท เป็นต้น รวมถึง ผู้ใช้บริการจะลงนามในเอกสารใดๆ เพื่อ
          รับทราบและตกลงยินยอมผูกพันตามข้อตกลงและเงื่อนไขในการใช้บริการผลิตภัณฑ์และ
          บริการของผู้ใช้บริการ ตามที่บริษัทพิจารณาเห็นสมควรและได้ร้องขอให้ดำเนินการ
        </p>
      </div>

      <!-- 3. การใช้บริการผลิตภัณฑ์และบริการ -->
      <div>
        <p class="font-weight-bold">
          3. การใช้บริการผลิตภัณฑ์และบริการ
        </p>
        <p>
          3.1. บริษัทจะไม่รับผิดชอบต่อความสูญเสีย และ/หรือ ความเสียหายไม่ว่าในลักษณะใดที่เป็นผล
          และ/หรือ อาจจะเป็นผลมาจากการใช้บริการ ผลิตภัณฑ์และบริการของ
          ผู้ใช้บริการ (ทั้งนี้ไม่ว่าทางตรงหรือทางอ้อม)
        </p>
        <p>
          3.2. บริษัทได้จัดให้มีข้อกำหนดด้านนโยบายความเป็นส่วนตัว (Privacy Policy)
          (รวมถึงที่จะได้มีการแก้ไขในอนาคต) ผู้ใช้บริการควรศึกษา ทำความเข้าใจ และ รับทราบ
          รายละเอียดต่าง ๆ ของข้อกำหนดดังกล่าวก่อนการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ
          ซึ่งผู้ใช้บริการสามารถเข้าถึง ศึกษา ตรวจสอบ และ จัดพิมพ์
          ข้อกำหนดด้านนโยบายความเป็นส่วนตัว (Privacy Policy)
        </p>
        <p>
          3.3 บริษัทให้ความพยายามอย่างเต็มที่ในการให้บริการแก่ผู้ใช้บริการอย่างไรก็ตาม
          บริษัทไม่สามารถรับรองผลลัพธ์ หรือ ผลสำเร็จใด (ไม่ว่าทางธุรกิจ กำไร หรือ อย่างอื่นใด)
          ที่ผู้ใช้บริการมุ่งหวังหรือประสงค์ที่จะได้รับจากการใช้บริการผลิตภัณฑ์และบริการ
          ที่ผู้ใช้บริการได้เลือกใช้บริการ และบริษัทจะไม่รับผิดชอบต่อความสูญเสียและ/หรือ
          ความเสียหายใดๆ ที่มีหรืออาจจะเกิดขึ้นไม่ว่าในกรณีใดๆ
        </p>
        <p>
          3.4 ไม่ว่าระหว่าง หรือ ภายหลังระยะเวลา การใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ
          ผู้ใช้บริการขอยืนยันต่อบริษัทว่า ผู้ใช้บริการจะไม่ให้ข้อมูล และ/หรือ
          แสดงความคิดเห็นใดๆ ในที่สาธารณะ หรือ ในระบบหรือรูปแบบที่ทำให้ข้อมูลสามารถ
          ถูกเข้าถึงได้ในวงกว้าง (รวมถึง สื่อสารมวลชน สื่อออนไลน์ และ/หรือ โซเชียลมีเดีย)
          ที่อาจจะทำให้เกิดความเสียหาย หรือ เสื่อมเสียต่อบริษัท (ไม่ว่าในรูปแบบใดๆ)
          อย่างไรก็ตามบริษัทยินดีน้อมรับคำติชมและคำแนะนำต่างๆ จากผู้ใช้บริการเพื่อนำมา
          ปรับปรุงการให้บริการของบริษัทต่อไป ซึ่งผู้ใช้บริการสามารถส่งคำติชมและคำแนะนำต่างๆ
          ให้แก่บริษัทมาได้ที่ lineagency@sellsuki.com
        </p>
        <p>
          3.5 ไม่ว่าระหว่างหรือ ภายหลังระยะเวลาการใช้บริการผลิตภัณฑ์และบริการของ
          ผู้ใช้บริการหากมีปัญหา และ/หรือ ข้อพิพาทใดๆ เกิดขึ้นระหว่างผู้ใช้บริการกับลูกค้าของ
          ผู้ใช้บริการและ/หรือบุคคลอื่นใดก็ตาม ที่เป็นผลมาจากการใช้บริการผลิตภัณฑ์และบริการ
          ของผู้ใช้บริการ ผู้ใช้บริการรับทราบและ จะรับผิดชอบในการดำเนินการใดๆ
          กับปัญหาดังกล่าวเอง บริษัทไม่มีหน้าที่ และ/หรือความรับผิดชอบในดำเนินการกับปัญหา และ/หรือ
          ข้อพิพาทดังกล่าวอนึ่ง ในกรณีที่บริษัทต้องเสียหาย (ไม่ว่าในรูปแบบใดๆ อันเป็นผล
          มาจากการดำเนินการใดๆ เกี่ยวปัญหาดังกล่าว ผู้ใช้บริการตกลงที่จะดำเนินการแก้ไขความเสียหาย
          ดังกล่าวให้หมดสิ้นไปและ/หรือ ชดเชยค่าเสียหายใดๆ ที่มีหรืออาจจะมีขึ้นแก่บริษัท
          รวมถึงกรรมการ ผู้บริหาร เจ้าหน้าที่ และ ตัวแทน ของบริษัท
        </p>
        <p>
          3.6 รูปภาพ รูปแบบ ข้อความ ข้อมูล ความเห็น และ/หรือ เนื้อหาต่างๆ ที่ผู้ใช้บริการนำมาใช้
          (รวมถึง รูปภาพ รูปแบบ ข้อความ ข้อมูล ความเห็น และ/หรือ เนื้อหาต่างๆ
          ที่มีผู้แสดงออก และ/หรือ โพสไว้ในเว็บไซต์หรือแอปพลิเคชันของผู้ใช้บริการ)
          ไม่ว่าในการใช้บริการผลิตภัณฑ์และบริการใดๆ ของผู้ใช้บริการ เช่น ใน เว็บไซต์หรือในเนื้อหา
          โฆษณานั้น จะถือเป็นความรับผิดชอบของผู้ใช้บริการแต่เพียงผู้เดียว บริษัทไม่มีหน้าที่ตรวจสอบ
          และ/หรือ คัดกรอง รูปภาพ รูปแบบ ข้อมูล และ เนื้อหาต่างๆ ดังกล่าว
          และบริษัทจะไม่รับผิดชอบต่อความเสียหายที่เกิดขึ้นเนื่องจากการใช้งาน
          การรุกล้ำสิทธิ์ส่วนบุคคล หรือปัญหาต่างๆ ที่เกิดขึ้นระหว่างผู้ใช้บริการกับบุคคลอื่นอีกทั้ง
          ผู้ใช้บริการจะต้องไม่นำมาใช้ และ/หรือ ยินยอมให้ใช้ รูปภาพ รูปแบบ ข้อความ
          ข้อมูล ความเห็น และ/หรือ เนื้อหาที่ผิดหรือ อาจจะผิดกฎหมาย และ/หรือศีลธรรมของสังคม
          ไม่ว่าในกรณีใดๆ ในกรณีที่บริษัทพบว่า ผู้ใช้บริการไม่ได้ดำเนินการให้เป็นไปตาม
          เงื่อนไขดังกล่าว บริษัทขอสงวนสิทธิ์ในการลบรูปภาพ รูปแบบ ข้อความ ข้อมูล ความเห็น
          และ/หรือ เนื้อหา เหล่านั้น หรือยกเลิกการใช้บริการผลิตภัณฑ์และบริการใดๆ
          ของผู้ใช้บริการที่ก่อหรือ อาจจะก่อให้เกิดปัญหา และ/หรือ ความเสียหายต่างๆ ดังกล่าว
          โดยบริษัทไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
        </p>
        <p>
          3.7 เมื่อได้รับการร้องขอจากบริษัท (ไม่ว่าระหว่าง หรือ ภายหลัง การใช้บริการผลิตภัณฑ์
          และบริการของผู้ใช้บริการ) ผู้ใช้บริการยินดีจะให้ความร่วมมือกับบริษัท ในการให้
          และ เปิดเผย ข้อมูล เอกสาร และ/หรือ หลักฐานต่างๆ ที่เกี่ยวกับการใช้บริการผลิตภัณฑ์
          และบริการของผู้ใช้บริการ แก่บริษัท และ ให้บริษัทเปิดเผย และ/หรือ ส่งมอบข้อมูล
          เอกสาร และ/หรือ หลักฐานดังกล่าว ให้แก่หน่วยงานราชการ และ องค์กรใดๆ
          ที่มีอำนาจตามกฎหมาย เพื่อปฏิบัติตาม กฎ ระเบียบ กฎหมาย และ/หรือ คำสั่ง ของหน่วยงาน
          ราชการ และ องค์กรใดๆ ที่มีอำนาจตามกฎหมายที่เกี่ยวข้องดังกล่าว
        </p>
        <p>
          3.8 ในการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ ผู้ใช้บริการรับทราบและตกลงว่า
          บริษัทไม่ได้ให้คำรับรองหรือยืนยันถึงคุณภาพ คุณค่า มูลค่า และ/หรือ คุณสมบัติใดๆ
          ของสินค้า ผลิตภัณฑ์ และ/หรือ บริการ ที่ผู้ใช้บริการ และ/หรือ บุคคลภายนอก
          นำมาเสนอหรือแสดงไว้ เกี่ยวกับการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ เช่น
          การแสดงไว้ในเว็บไซต์หรือในเนื้อหาโฆษณา อนึ่ง ในกรณีที่บริษัทต้องเสียหาย
          (ไม่ว่าในรูปแบบใดๆ) อันเป็นผลมาจากการดำเนินการเกี่ยวกรณีดังกล่าว ผู้ใช้บริการตกลง
          ที่จะดำเนินการแก้ไขความเสียหายดังกล่าวให้หมดสิ้นไป หรือชดเชยค่าเสียหายใดๆ
          ที่มีหรืออาจจะมีขึ้นแก่บริษัทรวมถึง กรรมการ ผู้บริหาร เจ้าหน้าที่ และ ตัวแทน ของบริษัท
        </p>
        <p>
          3.9 ในการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ ผู้ใช้บริการรับทราบและตกลงว่า
          บริษัทไม่ได้ให้คำรับรองหรือยืนยันว่าระบบเครือข่ายอินเทอร์เน็ต และ/หรือ การให้
          บริการโดยผู้ให้บริการในต่างประเทศ จะสามารถดำเนินการได้อย่างสมบูรณ์แบบ
          ไม่มีข้อบกพร่อง และ/หรือ มีเสถียรภาพตลอดเวลาการใช้บริการ พร้อมกันนี้ บริษัทขอ
          สงวนสิทธิ์ที่จะไม่รับผิดชอบถึงความสูญเสีย หรือ ความเสียหายใดๆ ที่มี หรือ
          อาจจะมีขึ้นจากการกรณีดังกล่าวทั้งสิ้นในกรณีที่ผู้ใช้บริการพบข้อบกพร่องใดๆ ของการใช้
          บริการผู้ใช้บริการสามารถแจ้งให้บริษัททราบถึงข้อบกพร่องดังกล่าวผ่านช่อง
          ทางการติดต่อสื่อสารในเงื่อนไขการให้บริการ
        </p>
        <p>
          3.10 ผู้ใช้บริการขอให้คำรับรองและยืนยันต่อบริษัทว่า ผู้ใช้บริการเข้าใจ รับทราบถึง
          และ จะปฏิบัติตาม บทบัญญัติของกฎหมายที่เกี่ยวข้องกับการใช้บริการผลิตภัณฑ์และ
          บริการของผู้ใช้บริการ (รวมถึง กฎ ระเบียบ กฎหมาย และ/หรือ คำสั่ง
          ของหน่วยงานราชการที่เกี่ยวข้อง) อย่างเคร่งครัด
        </p>
        <p>
          3.11 ผู้ใช้บริการรับทราบและเข้าใจว่า ในการให้บริการผลิตภัณฑ์และบริการต่างๆ
          แก่ผู้ใช้บริการ บริษัทไม่สามารถรับรองและยืนยันได้ว่า จะไม่มีบุคคลอื่นสามารถเข้าถึง
          ทำสำเนา แก้ไข เปลี่ยนแปลง และ/หรือ นำไปใช้ซึ่ง ข้อมูล เอกสาร และ/หรือ
          หลักฐานต่างๆ ที่เกี่ยวกับการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ (ไม่ว่าที่เป็น
          ความลับ หรือไม่ก็ตาม) และ/หรือ ทำ หรือ อาจจะทำให้เกิดความเสียหายใดๆ
          แก่สินค้าผลิตภัณฑ์และบริการต่างๆของผู้ใช้บริการ
        </p>
      </div>

      <!-- 4. การต่ออายุและยกเลิกใช้บริการ -->
      <div>
        <p class="font-weight-bold">
          4. การต่ออายุและยกเลิกใช้บริการ
        </p>
        <p>
          4.1 ผู้ใช้บริการสามารถยกเลิกใช้บริการผลิตภัณฑ์และบริการได้โดยส่งอีเมลแจ้งความประสงค์
          ขอยกเลิกการใช้บริการมาได้ที่ lineagency@sellsuki.com หรือแจ้งความ
          ประสงค์ขอยกเลิกการใช้บริการต่อเจ้าหน้าที่ของบริษัทที่ได้รับมอบหมายให้เป็น
          ผู้ให้บริการแก่ผู้ใช้บริการเป็นลายลักษณ์อักษรล่วงหน้าไม่น้อยกว่า 30 วัน หรือ ดำเนินการ
          ตามวิธีการขอยกเลิกการใช้บริการที่กำหนดไว้ในเงื่อนไขในการใช้บริการเฉพาะ
          รายผลิตภัณฑ์และบริการ ทั้งนี้ บริษัทขอสงวนสิทธิ์ที่จะไม่คืนเงินค่าบริการที่ผู้ใช้บริการได้
          ชำระแล้วทั้งหมดคืนให้แก่ผู้ใช้บริการ
        </p>
        <p>
          4.2 เพื่ออำนวยความสะดวกแก่ผู้ใช้บริการบริษัทจะพยายามติดต่อผู้ใช้บริการเพื่อ
          แจ้งเตือนผู้ใช้บริการก่อนหมดอายุการใช้บริการล่วงหน้า เพื่อให้ผู้ใช้บริการทำการต่ออายุ
          การใช้บริการได้ก่อนหมดอายุการใช้บริการ อย่างไรก็ตาม ผู้ใช้บริการยังคงมีหน้าที่
          ติดต่อกับบริษัทเพื่อแจ้งความประสงค์การต่ออายุการใช้บริการ หรือ การไม่ต่ออายุการ
          ใช้บริการ ดังนั้น หากบริษัทไม่ได้ติดต่อ หรือ ไม่สามารถติดต่อผู้ใช้บริการได้
          และผู้ใช้บริการ ไม่สามารถต่ออายุการใช้บริการได้ทันตามกำหนดเวลา บริษัทขอสงวนสิทธิ์ที่จะ
          ไม่รับผิดชอบต่อความเสียหายใดๆ อันเกิดขึ้น หรือ อาจจะเกิดขึ้นแก่ผู้ใช้บริการหรือบุคคลใดๆ
          อันเป็นผลมาจากการหมดอายุการใช้บริการ อนึ่ง หากผู้ใช้บริการไม่ได้ชำระ
          เงินต่ออายุการใช้บริการภายในระยะเวลาที่กำหนด บริษัทจะถือว่าการใช้บริการผลิตภัณฑ์
          และบริการของผู้ใช้บริการได้สิ้นสุดเมื่อหมดอายุการใช้บริการ
        </p>
      </div>

      <!-- 5. การติดต่อระหว่างผู้ใช้บริการกับบริษัท -->
      <div>
        <p class="font-weight-bold">
          5. การติดต่อระหว่างผู้ใช้บริการกับบริษัท และการเปลี่ยนแปลงกฎ ระเบียบ
          และเงื่อนไขการให้บริการผลิตภัณฑ์และบริการ
        </p>
        <p>
          5.1 การติดต่อระหว่างบริษัทกับผู้ใช้บริการ จะดำเนินการผ่านช่องทางการติดต่อสื่อสาร
          ทางอีเมลเป็นหลัก โดยผู้ใช้บริการท่านใดมีปัญหาการใช้บริการผลิตภัณฑ์และบริการ
          หรือประสงค์จะสอบถามเกี่ยวกับผลิตภัณฑ์และบริการสามารถส่งอีเมลมาได้ที่
          lineagency@sellsuki.com อย่างไรก็ตาม การติดต่อระหว่างบริษัทกับผู้ใช้บริการ อาจจะ
          มีรูปแบบเฉพาะเพิ่มเติมขึ้นอยู่กับการใช้บริการผลิตภัณฑ์และบริการเฉพาะราย
          ที่ผู้ใช้บริการเลือกใช้บริการ ซึ่งจะระบุวิธีการติดต่อดังกล่าวไว้ในเงื่อนไขในการใช้บริการ
          เฉพาะรายผลิตภัณฑ์และบริการของแต่ละผลิตภัณฑ์และบริการที่ผู้ใช้บริการเลือกใช้บริการ
        </p>
        <p>
          5.2 บริษัทอาจจะมีการเปลี่ยนแปลง กฎ ระเบียบ และ เงื่อนไข การให้บริการผลิตภัณฑ์และบริการ
          (รวมถึง เงื่อนไขในการใช้บริการ และ ข้อกำหนดด้านนโยบาย ความเป็นส่วนตัว (Privacy Policy)
          เพื่อความเหมาะสมอยู่เสมอ แม้ว่า เพื่ออำนวยความสะดวกให้แก่ผู้ใช้บริการ บริษัท จะพยายามแจ้ง
          ให้ผู้ใช้บริการทราบถึงการเปลี่ยนแปลง กฎ ระเบียบ และ เงื่อนไข การให้บริการผลิตภัณฑ์
          และบริการดังกล่าวผ่านทางเว็บไซต์ www.sellsuki.co.th บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลง
          กฎ ระเบียบ และ เงื่อนไข การให้บริการผลิตภัณฑ์และบริการดังกล่าว โดยไม่ต้องแจ้ง
          ให้ผู้ใช้บริการทราบล่วงหน้า และ จะไม่รับผิดชอบความเสียหายที่เกิดแก่ผู้ใช้
          บริการหรือบุคคลอื่นใดอันเนื่องมาจากการเปลี่ยนแปลง กฎ ระเบียบ และ เงื่อนไข
          การให้บริการผลิตภัณฑ์และบริการไม่ว่าในกรณีใดๆ
        </p>
      </div>

      <!-- 6. การยกเลิกการใช้บริการผลิตภัณฑ์และบริการ -->
      <div>
        <p class="font-weight-bold">
          6. การยกเลิกการใช้บริการผลิตภัณฑ์และบริการ
        </p>
        <p>
          บริษัทขอสงวนสิทธิ์ในการยกเลิกการใช้บริการผลิตภัณฑ์และบริการของผู้ใช้บริการ
          หากบริษัทเห็นว่าผู้ใช้บริการไม่ปฏิบัติตาม กฎ ระเบียบ และเงื่อนไขการให้บริการ
          ผลิตภัณฑ์และบริการ (รวมถึง เงื่อนไขในการใช้บริการ และ ข้อกำหนดด้าน
          นโยบายความเป็นส่วนตัว (Privacy Policy) โดยบริษัทไม่จำเป็นต้องแจ้งให้ผู้ใช้
          บริการทราบล่วงหน้า และบริษัทจะไม่รับผิดชอบความเสียหายใดๆ ที่เกิด หรือ
          อาจจะเกิดขึ้น แก่ผู้ใช้บริการหรือบุคคลอื่นใดอันเนื่องมาจากการดำเนินการดังกล่าว
          นอกเหนือไปจากเงื่อนไขในการใช้บริการทั่วไปข้างต้นแล้ว ผู้ใช้บริการต้องรับทราบ
          และปฏิบัติตามเงื่อนไขในการใช้บริการเฉพาะซึ่งได้กล่าวไว้ในส่วนต่อไปโดยเคร่งครัด
        </p>
      </div>

      <!-- 7. ข้อจำกัดความรับผิดชอบ -->
      <div>
        <p class="font-weight-bold">
          7. ข้อจำกัดความรับผิดชอบ
        </p>
        <p>
          การเรียกร้องใดๆ ของท่านต่อบริษัทนั้นไม่ว่ากรณีใดๆ บริษัทจะมีความรับผิด
          ไม่เกินมูลค่าทั้งหมดของจำนวนเงินที่ท่านได้ชำระตามจริงสำหรับค่าบริการ
          เนื่องจากการใช้บริการระหว่างที่มีการเรียกร้องนั้นๆ เกิดขึ้น และไม่มีกรณีใดที่
          บริษัท ต้องรับผิดต่อท่านหรือบุคคลใดๆ ไม่ว่าทางตรง ทางอ้อม สำหรับค่า
          เสียหายเชิงลงโทษค่าเสียหายเชิงเศรษฐกิจ ค่าเสียหายที่อาจเกิดขึ้นในอนาคต
          หรือค่าเสียหายหรือความสูญเสียอื่นๆ บริษัทไม่ต้องรับผิดต่อความเสียหายหรือ
          การบาดเจ็บใดๆ ซึ่งอาจเกิดขึ้นกับ หรือเป็นเหตุให้ท่านหรือบุคคลใดๆ ที่ท่านได้
          ใช้บริการ รวมถึงแต่ไม่จำกัดเฉพาะความสูญเสีย ความเสียหาย หรือการบาดเจ็บ
          ที่เกิดขึ้นจากหรือเกี่ยวข้องกับบริการ แอปพลิเคชัน และ/หรือซอฟท์แวร์ รวมถึง
          แต่ไม่จำกัดเฉพาะการใช้ หรือการไม่สามารถใช้บริการ แอปพลิเคชัน และ/หรือ
          ซอฟท์แวร์ได้ การที่ท่านได้ให้ความไว้วางใจในความสมบูรณ์ ความแม่นยำ หรือ
          ความมีอยู่ของโฆษณาใดๆ หรือเป็นผลมาจากความสัมพันธ์ หรือการทำธุรกรรม
          ใดๆ ระหว่างท่านและผู้ให้บริการซึ่งเป็นบุคคลภายนอกบริษัท ผู้ซื้อโฆษณา หรือ
          ผู้สนับสนุนซึ่งโฆษณาของบุคคลเหล่านั้นปรากฎอยู่หน้าเว็บไซต์ หรือถูกอ้างอิง
          ถึงจากการใช้บริการ แอปพลิเคชันและ/หรือซอฟท์แวร์ แม้ว่าบริษัท และ/หรือ
          ผู้อนุญาตให้ใช้สิทธิของบริษัทได้รับคำแนะนำเกี่ยวกับความเป็นไปได้ของค่า
          เสียหายดังกล่าวมาก่อน
        </p>
      </div>

      <!-- 8. การส่งหนังสือบอกกล่าว -->
      <div>
        <p class="font-weight-bold">
          8. การส่งหนังสือบอกกล่าว
        </p>
        <p>
          บริษัทอาจส่งหนังสือบอกกล่าวให้ท่านโดยการแจ้งเตือนบนแอปพลิเคชัน ส่ง
          ไปรษณีย์อิเล็กทรอนิกส์ ไปยังที่อยู่ทางไปรษณีย์อิเล็กทรอนิกส์ ของท่านตาม
          ข้อมูลที่บริษัทมี หรือการสื่อสารด้วยลายลักษณ์อักษรส่งไปหาท่านด้วยไปรษณีย์
          ลงทะเบียน หรือไปรษณีย์ที่ชำระค่าบริการล่วงหน้าไปยังที่อยู่ของท่านตามข้อมูล
          ที่บริษัทมีท่านอาจส่งหนังสือบอกกล่าวไปยังบริษัท (หนังสือบอกกล่าวดังกล่าว
          จะถือว่าได้ส่งแล้วต่อเมื่อบริษัทได้รับ) โดยหนังสือส่งผ่านทางผู้ให้บริการขนส่ง
          หรือไปรษณีย์ลงทะเบียนไปยังบริษัทโดยใช้รายละเอียดของการติดต่อตามที่ระบุ
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermAndConditionsPage'
}
</script>

<style lang="scss" scoped>
#privacy-policy-page {
    background-color: #E5E5E5;

    > .background-header {
        height: 200px;
        background-color: #2C395A;

        > .logo {
            z-index: 1;
        }
    }

    > .container {
        background-color: #FFFFFF;
        border-radius: 20px 20px 0px 0px;
        margin-top: -50px;
        padding: 30px;
        padding-top: 90px;

        > div {
            line-height: 24px;
            margin-bottom: 50px;

            > h1 {
                font-size: 36px;
                line-height: 54px;
                margin-bottom: 20px;
            }

             p {
                margin-bottom: 0px;
            }
        }
    }
}

@media only screen and (max-width: 600px) {
    #privacy-policy-page {
        > .background-header {
            > .logo {
                margin-top: 50px;
            }
        }

        > .container {
            margin-top: 40px;
            padding-top: 50px;

            > div {
                > h1 {
                    font-size: 30px;
                    line-height: 45px;
                }
            }
        }
    }
}
</style>
